export default __webpack_public_path__ + "static/media/harshita.1eef0732.jpg";